// extracted by mini-css-extract-plugin
export default {"customDatesLabel":"zeCQ9"};